import { Component, EventEmitter, OnInit, Output, ElementRef, ViewChild, HostListener, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectLanguageData } from 'src/app/state/selectors'; // adjust path if needed
import { startWith } from 'rxjs';
import * as XLSX from 'xlsx';
import { DomSanitizer, SafeResourceUrl, SafeHtml } from '@angular/platform-browser';
import { Editor } from 'ngx-editor';
import { Toolbar } from 'ngx-editor';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { RxFormBuilder, RxwebValidators } from '@rxweb/reactive-form-validators';
import { FormGroup } from '@angular/forms';
import { PricingMatrixHelper } from '../../../utils/pricing-matrix.helper';
import { capitalizeFirst, toLowerCase } from 'src/utils/string-utils';

@Component({
  selector: 'app-create-supplier',
  templateUrl: './create-supplier.component.html',
  styleUrls: ['./create-supplier.component.css']
})
export class CreateSupplierComponent implements OnInit {
  @Output() onClose = new EventEmitter<void>();
  @Input() existingSuppliers: any[] = [];
  @Input() refreshParentData!: () => void;

  @ViewChild('pdfCanvas') pdfCanvasRef!: ElementRef<HTMLCanvasElement>;
  constructor(private store: Store<{ languageData: [] }>, private domSanitizer: DomSanitizer, private sanitizer: DomSanitizer, private formBuilder: RxFormBuilder, private http: HttpClient) {
    this.languageData$ = store.select(selectLanguageData);
  }

  closeComponent() {
    window.location.reload()
    this.onClose.emit();
    if (this.refreshParentData) {
      this.refreshParentData();
    }
  }

  // *****************************Supplier Name List********************************
  supplierExists = false;

  matchedSupplierName: string | null = null;
  onSupplierInput(value: string) {
    this.supplierName = value;
    const trimmedValue = value.trim().toLowerCase();

    if (!trimmedValue) {
      this.matchedSupplierName = null;
      return;
    }

    const match = this.existingSuppliers.find(supplier =>
      supplier.name.toLowerCase().startsWith(trimmedValue)
    );

    this.matchedSupplierName = match ? match.name : null;
  }

  // *********************************VALIDATION FOR CONTACT FORM*****************************//
  contactForm!: FormGroup;
  submitted = false;
  onRoleChangeOfContactInfo(event: any) {
    const roleValue = event.target.value;
    this.showOther = roleValue === 'Other';

    const otherControl = this.contactForm.get('contact_other');
    if (this.showOther) {
      otherControl?.setValidators(RxwebValidators.required());
    } else {
      otherControl?.clearValidators();
      otherControl?.setValue('');
      this.contact_other = '';
    }
    otherControl?.updateValueAndValidity();
  }




  // ************ Provinces ***********************//
  // country setting
  countries = [
    { id: 2, name: 'Canada' },
    { id: 1, name: 'USA' }];

  productIdentifier = [
    { id: 1, name: 'Mental Health & Wellbeing' },
    { id: 2, name: 'Health & Dental' },
    { id: 3, name: 'Life & Disability Protection' },
    { id: 4, name: 'Private Health' },
    { id: 5, name: 'Other' }
  ];


  // it is common for country and product identifier
  countryDropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'name',
    allowSearchFilter: false,
    closeDropDownOnSelection: true
  };

  showOtherInput: boolean = false;
  otherInputForProductIdentiFier: string = null;
  onSelectProductIdentityFier(item: any): void {
    console.log("onSelectProductIdentityFier :", item);
    this.showOtherInput = item.name === 'Other';
  }

  onDeselectProductIdentityFier(item: any): void {
    if (item.name === 'Other') {
      this.showOtherInput = false;
      this.otherInputForProductIdentiFier = '';
    }
  }
  // provinces: any[] = [];
  provinces = [
    { id: 1, name: 'Alberta', shortName: 'AB' },
    { id: 2, name: 'British Columbia', shortName: 'BC' },
    { id: 3, name: 'Manitoba', shortName: 'MB' },
    { id: 4, name: 'New Brunswick', shortName: 'NB' },
    { id: 5, name: 'Newfoundland and Labrador', shortName: 'NL' },
    { id: 6, name: 'Nova Scotia', shortName: 'NS' },
    { id: 7, name: 'Ontario', shortName: 'ON' },
    { id: 8, name: 'Prince Edward Island', shortName: 'PE' },
    { id: 9, name: 'Quebec', shortName: 'QC' },
    { id: 10, name: 'Saskatchewan', shortName: 'SK' },
    { id: 11, name: 'Northwest Territories', shortName: 'NT' },
    { id: 12, name: 'Nunavut', shortName: 'NU' },
    { id: 13, name: 'Yukon', shortName: 'YT' }
  ];


  selectedProvinces: any[] = [];

  filteredProvinces: any[] = [];

  dropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'shortName',
    itemsShowLimit: 2,
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    enableCheckAll: true,
    allowSearchFilter: true,
  };

  onItemSelect(item: any) {
    this.updateFilteredProvinces();
    console.log('Selected:', item);
    console.log("selected zz:", this.selectedProvinces);
  }


  onSelectAll(items: any) {
    console.log('All Selected:', items);
    this.updateFilteredProvinces();
    this.filteredProvinces = [...items];
  }


  onDeSelectAll(items: any) {
    this.filteredProvinces = [];
  }

  onItemDeSelect(item: any) {
    this.updateFilteredProvinces();
  }
  //here we are filtering provinces to show in pricing area section dropdown
  updateFilteredProvinces() {
    this.filteredProvinces = this.selectedProvinces;
  }




  //----------**** STRING MULTI LANGUAGE*******-------------
  lang: any = {};
  languageData$: any;
  selectedLanguage: string;

  public getLanguageTokens() {
    this.languageData$ = this.store.select(state => state.languageData).pipe(startWith([]));

    this.languageData$.subscribe(data => {
      if (!data || !data.languageData || Object.keys(data.languageData).length === 0) {
        console.log('No language data found');
        return;
      }

      setTimeout(() => {
        this.lang = {};
        this.selectedLanguage = sessionStorage.getItem("language") || 'english';
        for (let token of data.languageData) {
          this.lang[token.key] = token[this.selectedLanguage];
        }
      }, 0);
    });
  }

  //----------****Supplier Auto ID Generated*******-------------
  supplierID: string = ''
  generateSupplierID(): string {
    const randomLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26));
    const randomNumber = Math.floor(1000000000 + Math.random() * 9000000000);
    return `${randomLetter}-${randomNumber}`;
  }

  //----------****CONTACT INFORMATION SECTION*******-------------
  supplierName: string = '';
  firstName: string = '';
  lastName: string = '';
  email: string = '';
  phone: string = '';
  role: string = '';
  contact_other: string = '';

  showOther: boolean = false;

  selectedIndex: Number = null;

  showContactModal: boolean = false;
  showProductModal: boolean = false;

  showContactEditModal: boolean = false;
  showDeleteConfirm: boolean = false;
  contacts: any[] = [];

  //roles
  roles: string[] = [
    'Accountant',
    'Key Account Manager',
    'Product Manager',
    'Underwriter',
    'Other'
  ];
  //save contact
  onSaveContact() {
    this.submitted = true;
    const contact = {
      firstName: capitalizeFirst(this.firstName),
      lastName: capitalizeFirst(this.lastName),
      email: toLowerCase(this.email),
      phone: this.phone,
      role: this.contact_other.length > 0 ? this.contact_other : capitalizeFirst(this.role)
    };
    if (this.contactForm.valid) {
      this.contacts.push(contact);
      this.firstName = '';
      this.lastName = '';
      this.email = '';
      this.phone = '';
      this.role = '';
      this.showOther = false
      this.showContactModal = false;
      console.log("Saved contact:", contact);
      console.log('Form Submitted', this.contactForm.value);
      // Reset form state
      this.contactForm.reset();
      this.submitted = false;
    } else {
      console.log("Please fill all contact information :", this.contactForm.value)
    }
  }

  // formatPhoneNumber() {
  //   // Keep only numbers
  //   let digitsOnly = this.phone.replace(/\D/g, '');

  //   // Limit to exactly 11 digits
  //   if (digitsOnly.length > 10) {
  //     digitsOnly = digitsOnly.substring(0, 10);
  //   }

  //   // If not 11 yet, don't format
  //   if (digitsOnly.length < 10) {
  //     this.phone = digitsOnly;
  //     return;
  //   }

  //   // Format to: +1 (555) 555-1212
  //   this.phone = `+1 (${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3, 6)}-${digitsOnly.slice(6, 10)}`
  // }
  formatPhoneNumber(raw: string): string {
    const cleaned = raw.replace(/\D/g, '');

    if (cleaned.length >= 10) {
      const area = cleaned.slice(-10, -7);
      const prefix = cleaned.slice(-7, -4);
      const line = cleaned.slice(-4);
      return `+1 (${area}) ${prefix}-${line}`;
    }

    return raw;
  }


  // show other
  onRoleChange(event: any) {
    const selectedValue = event.target.value;
    this.showOther = selectedValue === 'Other';

    const otherControl = this.contactForm.get('contact_other');

    if (this.showOther) {
      // Apply required validator
      otherControl?.setValidators(RxwebValidators.required());
    } else {
      // Remove validator and clear value
      otherControl?.clearValidators();
      otherControl?.setValue('');
      this.contact_other = '';
    }

    otherControl?.updateValueAndValidity();
  }

  // update contact
  editSupplier(index: number) {
    this.showContactEditModal = true;
    const selectedContact = this.contacts[index];
    console.log("selectedContact :", selectedContact);
    this.firstName = selectedContact.firstName;
    this.lastName = selectedContact.lastName;
    this.email = selectedContact.email;
    this.phone = selectedContact.phone;

    this.role = (selectedContact.role === "Accountant" || selectedContact.role === "Key Account Manager" || selectedContact.role === "Product Manager" || selectedContact.role === "Underwriter") ? selectedContact.role : 'Other'
    this.selectedIndex = index
    if (this.role === "Other") {
      this.contact_other = selectedContact.role;
      this.showOther = true;
    }

  }
  //for updating contact
  onUpdateContact(index: number) {
    this.submitted = true;

    if (this.contactForm.invalid) {
      return; // Stop if validation fails
    }

    this.contacts[index] = {
      firstName: capitalizeFirst(this.firstName),
      lastName: capitalizeFirst(this.lastName),
      email: toLowerCase(this.email),
      phone: this.phone,
      role: this.role === 'Other' ? this.contact_other : capitalizeFirst(this.role)
    };



    // Reset form and state
    this.showContactEditModal = false;
    this.firstName = '';
    this.lastName = '';
    this.email = '';
    this.phone = '';
    this.role = '';
    this.contact_other = '';
    this.showOther = false;
    this.submitted = false;

    this.contactForm.reset(); // Reset reactive form too
  }

  // close update contact popup
  onCloseEditPopup() {
    this.firstName = '';
    this.lastName = '';
    this.email = '';
    this.phone = '';
    this.role = ''
    this.contact_other = ''
    this.showOther = false;


    this.showContactEditModal = false;
    this.showContactModal = false;
    this.contactForm.reset();
    this.submitted = false;
  }


  // delete contact 
  indexNumberForDelete: Number = null;
  selectedContact = {
    name: '',
    role: ''
  };

  deleteContact(contact: any, index: number) {
    this.selectedContact.name = contact.firstName + " " + contact.lastName;
    this.selectedContact.role = contact.role;
    this.indexNumberForDelete = index;
    this.showDeleteConfirm = true;
  }
  onConfirmDelete(index: number) {
    this.contacts.splice(index, 1);
    this.showDeleteConfirm = false;
  }
  onCancelDelete() {
    this.indexNumberForDelete = null;
    this.showDeleteConfirm = false;
  }
  allowOnlyNumbers(event: KeyboardEvent): void {
    const allowedKeys = [
      'Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'
    ];

    if (allowedKeys.includes(event.key)) {
      return;
    }

    const isDigit = /^[0-9]$/.test(event.key);
    if (!isDigit) {
      event.preventDefault(); // Block anything that's not a digit
    }
  }

  allowOnlyNumbersForPhoneNumber(event: KeyboardEvent, inputValue: string) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'];

    // Allow control keys
    if (allowedKeys.includes(event.key)) {
      return;
    }

    // Prevent if not a number
    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }

    // Prevent if already 11 digits
    if (inputValue.length >= 10) {
      event.preventDefault();
    }
  }

  //----------****SERVICE LEVEL SECTION*******-------------


  age_: boolean = false;
  minAge: number | null = null;
  maxAge: number | null = null;
  childAgeOut: number | null = null;
  studentAgeOut: number | null = null;


  //----------**** Add Product *******-------------
  products: any[] = [];
  product_ID: string = "";
  product_name: string = "";
  product_indetifier: string = "";
  referenceID: string = "";
  product_country = [{ id: 2, name: 'Canada' }];
  effective_Distribution_Date: string = new Date().toISOString().split('T')[0];
  distribution_Country: string = '';
  distribution_Province: string = '';
  renewalDate: Date = null;
  selectedFileName: string = '';
  selectedBooklet: string = '';
  isCOB: boolean = null;
  billingType: string = "";
  paymentOption: string = "";
  expected_Payment_Date: Date = null;
  bank_code: Number = null;
  transit: Number = null;
  account_number: Number = null;

  onBillingTypeChange() {
    this.paymentOption = "PAD From GB";
  }

  //it is validation for showing Service Section 
  get isProductValidForFirstRow(): boolean {
    const data = (
      this.product_ID.trim() !== '' &&
        this.product_name.length > 3 &&
        this.supplierID.length > 3 &&
        this.effective_Distribution_Date !== null &&
        this.product_country[0].name.trim() !== '' &&
        this.selectedProvinces.length > 0 &&
        this.renewalDate ? true : false
    )
    return data;
  }
  //it is validation for showing Prodct Details
  get isProductValidForSecondRow(): boolean {
    const data = (
      this.age_ && this.minAge && this.maxAge &&
      this.isCOB
    )
    return data
  }

  //it is validation for showing Pricing Section
  get isProductValidForThirdRow(): boolean {
    const data = (
      this.savedContent && this.savedProductResourceContent && this.bookletFileName
    ) ? true : false;
    return data
  }

  // it is validation for showing vendor and pricing 
  get isProductValidForVendorAndPricing(): boolean {
    let billing = false;
    if (this.billingType === 'self-billing') {
      billing = !!(this.bank_code && this.transit && this.account_number);
    } else if (this.billingType === 'invoiced') {
      if (this.paymentOption === 'EFT to Vendor') {
        billing = !!(this.bank_code && this.transit && this.account_number);
      } else if (this.paymentOption === 'PAD From GB') {
        billing = this.expected_Payment_Date ? true : false
      }
    }
    return billing;
  }

  // it is validation for Pricing section
  get isPricingSection(): boolean {
    return this.selectedBaseUnit && this.taxApplicable
    // return true
  }

  onSaveProduct() {
    this.tieredRows = this.tieredRows.map((item, index) => ({
      ...item,
      id: index + 1
    }))
    this.ageBands = this.ageBands.map((item, index) => ({
      ...item,
      id: index + 1
    }))
    this.variantRows = this.variantRows.map((item, index) => ({
      ...item,
      id: index + 1
    }))
    this.categoryRows = this.categoryRows.map((item, index) => ({
      ...item,
      id: index + 1
    }))

    const flatFields = this.rows.flatMap(row => row.fields).map((item, index) => ({
      ...item,
      id: index + 1
    }));

    const selectedSelfBFields = flatFields
      .filter(field => this.selectedSelfBillingFields.includes(field.fieldName))
      .map((field, index) => ({
        ...field,
        id: index
      }));

    const data = {
      version: 'v1.0',
      productInfo: {
        productId: this.product_ID,
        productName: this.product_name,
        effectiveDistributionDate: this.effective_Distribution_Date,
        productCountry: this.product_country,
        selectedProvinces: this.selectedProvinces,
        productIdentifier: this.product_indetifier,
        productNewInputIdentifier: this.otherInputForProductIdentiFier,
        renewalDate: this.renewalDate
      },
      limits: {
        isCOB: this.isCOB,
        isAgeLimitEnabled: this.age_,
        minAge: this.minAge,
        maxAge: this.maxAge,
        childAgeOut: this.childAgeOut,
        studentAgeOut: this.studentAgeOut
      },
      productDetails: {
        bookletFile: this.pdfBase64Data,
        productResourceContent: this.editorContentForProductResource,
        productResourceHTML: this.safeHtmlContentForProduct_Resource,
        tileDescriptionContent: this.editorContent,
        tileDescriptionHTML: this.safeHtmlContent,
        bookletFileName: this.bookletFileName,
        productResourceFileName: this.selectedFileName,
        tileFileName: this.tileFileName,
        billingType: this.billingType,
        paymentOption: this.paymentOption,
        bandCode: this.bank_code,
        transit: this.transit,
        accountNumber: this.account_number,
        expectedPaymentDate: this.expected_Payment_Date
      },
      vendorInvoicingAndPaymentMethod: {
        billingType: this.billingType,
        paymentOption: this.paymentOption,
        eftToVendor: {
          bankCode: this.bank_code,
          transit: this.transit,
          accountNumber: this.account_number
        },
        expectedPaymentDate: this.expected_Payment_Date
      },
      pricing: {
        isBaseAmountApplicable: this.isBaseAmount,
        baseAmount: this.selectedBaseUnit,
        isPriceInclusiveOfTax: this.inclusiveTax,
        isTaxApplicable: this.taxApplicable,
        taxTypes: this.taxTypes
      },
      areas: {
        noOfAreas: this.noOfPricingAreas,
        areasData: this.pricingAreaRows
      },
      tiers: {
        isTierEnabled: this.isTiered,
        noOfTiers: this.noOfTiered,
        tiersData: this.tieredRows
      },
      ageBands: {
        isAgeBandEnabled: this.isAgeBanded,
        noOfAgeBands: this.noOfAgeBands,
        ageBandsData: this.ageBands
      },
      variants: {
        isVariantEnabled: this.isVariantEnabled,
        noOfVariants: this.noOfVariants,
        variantsData: this.variantRows
      },
      serviceLevel: {
        isServiceLevelEnabled: this.isCategory,
        noOfServiceLevel: this.noOfCategories,
        servicesData: this.categoryRows
      },
      pricingMatrix: this.pricingMatrix,
      signUpData: flatFields,
      provisioningAndReporting: {
        isProvisioningEnabled: this.isProvisioning,
        provisioning: {
          url: this.provisioningUrl,
          username: this.provisioningUsername,
          password: this.provisioningPassword
        },
        isReportingEnabled: this.isReporting,
        reportingFileType: this.selectedReportingFileTypes,
        is2FAEnabled: this.is2FA,
        isSelfBillingEnabled: this.isSelfBilling,
        reportingPeriod: {
          startMonth: this.selectedStartMonth,
          endMonth: this.selectedEndMonth
        },
        fieldsForSelfBilling: selectedSelfBFields,
        isCensusEnabled: this.isCensus,
        selectedCensusFields: this.selectedCensusFields,
        isSelfBillingAndCensusEnabled: this.isSelfBillingAndCensusEnabled,
        isMaintainHistoryForCensusReporting: this.isMaintainHistoryForCensusReporting
      }
    };

    this.products.push(data);
    this.showProductModal = false;

    console.log("Saved Product:", this.products);
  }

  // show excel table for tile description
  excelData: any[][] = [];
  showTileExcelPopup: boolean = false

  //handle booklet description file
  bookletData: any[][] = [];
  showBookletPopup: boolean = false;
  showBookletExcelPopup: boolean = false;
  previewHtml: SafeHtml | null = null;
  showPopupForBookletChooseFile: boolean = false;
  selectedBookletChooseFileName: string = "";

  onBookletFileChange(event: any) {
    const target: DataTransfer = <DataTransfer>event.target;
    if (target.files.length !== 1) return;
    const file: File = target.files[0];
    this.selectedBooklet = file.name;
    const reader: FileReader = new FileReader();

    reader.onload = (e: any) => {
      const bstr: string = e.target.result;
      const workbook: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
      const sheetName: string = workbook.SheetNames[0];
      const worksheet: XLSX.WorkSheet = workbook.Sheets[sheetName];
      const data = <any[][]>XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      this.bookletData = data;
    };

    reader.readAsBinaryString(file);
  }

  pdfBase64Data: string | null = null;

  onFileSelecteds(event: any) {
    const file: File = event.target.files[0];
    if (!file) return;

    this.selectedBookletChooseFileName = file.name;
    const reader = new FileReader();
    reader.onload = () => {
      const binaryData = reader.result as ArrayBuffer;

      const rtfContent = reader.result as string;

      const html = this.convertRtfToHtml(rtfContent);

      this.previewHtml = this.sanitizer.bypassSecurityTrustHtml(html);

    };

    reader.readAsText(file);
    this.showPopupForBookletChooseFile = true;
  }
  convertRtfToHtml(rtf: string): string {
    return rtf
      .replace(/\\par[d]?/g, '<br>')
      .replace(/{\\[^}]+}/g, '')
      .replace(/\\'[0-9a-fA-F]{2}/g, '')
      .replace(/\\[^ ]+ ?/g, '')
      .replace(/{|}/g, '');
  }

  // generate ProductID
  generateProductID(): string {
    const randomLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26));
    const randomNumber = Math.floor(10000 + Math.random() * 90000);
    return `${randomLetter}-${randomNumber}`;
  }


  onProductModel() {
    this.showProductModal = true;
    this.product_ID = this.generateProductID()
  }


  // For Tile Description File
  tileFileName: string = '';
  tileTextContent: string | null = null;
  tileExcelData: any[][] = [];
  tileSafeUrl: SafeResourceUrl | null = null;
  tilePreviewType: 'text' | 'excel' | 'pdf' | 'doc' | 'unsupported' | null = null;

  // For Booklet File
  bookletFileName: string = '';
  bookletTextContent: string | null = null;
  bookletExcelData: any[][] = [];
  bookletSafeUrl: SafeResourceUrl | null = null;
  bookletPreviewType: 'text' | 'excel' | 'pdf' | 'doc' | 'unsupported' | null = null;

  handleBoookletFile(event: any): void {
    const file = event.target.files[0];
    if (!file) return;

    this.bookletFileName = file.name;
    const ext = file.name.split('.').pop()?.toLowerCase();
    const reader = new FileReader();

    if (['txt', 'csv', 'json', 'xml', 'html', 'doc', 'docx'].includes(ext!)) {
      reader.onload = () => {
        this.pdfBase64Data = (reader.result as string).split(',')[1];
        this.tilePreviewType = 'text';
        this.tileTextContent = reader.result as string;
      };
      reader.readAsText(file);
    } else if (ext === 'pdf') {
      reader.onload = () => {
        this.pdfBase64Data = (reader.result as string).split(',')[1];
        this.tilePreviewType = 'pdf';
        this.tileSafeUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(reader.result as string);
      };
      reader.readAsDataURL(file);
    } else {
      this.tilePreviewType = 'unsupported';
    }
  }

  // reset methods
  resetTilePreview(): void {
    // Clear the inputs
    this.showTileExcelPopup = false;
  }

  resetBookletPreview() {
    this.showBookletExcelPopup = false;
  }



  product_resource_editor!: Editor;
  product_resource_html = '';
  saved_product_resource_info: string | null = null;
  show_product_resource_editor: boolean = false;
  show_product_resource_preview: boolean = false;
  safe_product_resource_html: SafeHtml;

  onProductResourceInfoCreate() {
    this.show_product_resource_editor = true;
    this.product_resource_html = this.saved_product_resource_info || '';
  }

  // Save Product Resource Info
  onProductResourceInfoSave(): void {
    // Step 1: Store the editor content for preview
    this.saved_product_resource_info = this.product_resource_html;
    this.safe_product_resource_html = this.sanitizer.bypassSecurityTrustHtml(
      this.product_resource_html
    );
    this.show_product_resource_editor = false;
  }

  onProductResourceInfoKeyDown(event: KeyboardEvent): void {
    // If only Enter is pressed (not Shift+Enter), simulate Shift+Enter behavior
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault(); // prevent default behavior

      const selection = window.getSelection();
      if (!selection || selection.rangeCount === 0) return;

      const range = selection.getRangeAt(0);

      // insert a <br> tag
      const br = document.createElement('br');
      range.insertNode(br);

      // Optional: Add second <br> for paragraph spacing
      // range.insertNode(document.createElement('br'));

      // Move cursor after the <br>
      range.setStartAfter(br);
      range.setEndAfter(br);

      selection.removeAllRanges();
      selection.addRange(range);
    }
  }



  // *****************************ngx-editor******************************************* //

  toolbar: Toolbar = [
    ['bold', 'italic', 'underline'],
    ['strike', 'code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];

  onKeyDown(event: KeyboardEvent) {
    // If only Enter is pressed, simulate Shift + Enter behavior
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault(); // prevent default behavior

      const selection = window.getSelection();
      if (!selection || selection.rangeCount === 0) return;

      const range = selection.getRangeAt(0);

      // insert a <br> tag
      const br = document.createElement('br');
      range.insertNode(br);

      // Add a second <br> if you want more space (like paragraph feel)
      // range.insertNode(document.createElement('br'));

      // move the cursor after the <br>
      range.setStartAfter(br);
      range.setEndAfter(br);

      selection.removeAllRanges();
      selection.addRange(range);
    }
  }



  editor!: Editor;
  html = '';
  showEditor = false;
  savedContent = '';
  savedProductResourceContent = '';
  previewContent: boolean = false;
  showBookletPreview: boolean = false;
  safeHtml: SafeHtml;

  onTileFileSave(): void {
    // Step 1: Store the editor content for preview
    this.savedContent = this.editorContent;
    this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(this.html);
    this.safeHtmlContent = this.sanitizer.bypassSecurityTrustHtml(this.editorContent);
    this.showTileQuillEditor = false;
    // this.editorContent = null;
  }
  onProductResourceFileSave(): void {
    // Step 1: Store the editor content for preview
    this.savedProductResourceContent = this.editorContentForProductResource;
    this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(this.html);
    this.safeHtmlContentForProduct_Resource = this.sanitizer.bypassSecurityTrustHtml(this.editorContentForProductResource);

    this.showProduct_Resource_QuillEditor = false;
    // this.editorContent = null;
  }
  onCanceloOfTileDescription(): void {
    this.showTileQuillEditor = false
    this.editorContent = null;
  }
  onCanceloOfProductResourceDescription(): void {
    this.showProduct_Resource_QuillEditor = false
    // this.editorContentForProductResource = null;
  }
  // Pricing Section// ****************Pricing Area***************//

  isBaseAmount: boolean = false;
  taxApplicable: boolean = false;
  taxTypes = {
    hst: false,
    pst: false
  };

  inclusiveTax: boolean = false;

  ageBanded: boolean = false;
  ageBandCount: number | null = null;
  pricingAreaRows: any[] = [
    {
      area: 1,
      name: '',
      selectedProvinces: []
    }
  ];


  noOfPricingAreas: number | null = 1;


  // defininig variable for holding each row value
  ageBandData: {
    ageBand: string;
    maleNonSmoker: string;
    maleSmoker: string;
    femaleSmoker: string;
    femaleNonSmoker: string;
  }[] = [];

  //pricing provinces setting
  pricingProvincesdropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'shortName',
    itemsShowLimit: 1,
    allowSearchFilter: true,
    enableCheckAll: true,
    closeDropDownOnSelection: false
  };
  //increase table rows 
  generatePricingAreaRows(count: number) {
    this.pricingAreaRows = [];
    for (let i = 0; i < count; i++) {
      this.pricingAreaRows.push({
        area: i + 1,
        name: '',
        selectedProvinces: []
      });
    }
  }

  // Filtered list per row
  getAvailableProvinces(index: number) {
    const selectedInOthers = this.pricingAreaRows
      .filter((_, i) => i !== index)
      .flatMap(r => r.selectedProvinces.map(p => p.id));

    return this.filteredProvinces.filter(
      p => !selectedInOthers.includes(p.id)
    );
  }

  // 👇 Selection & De-Selection Logic
  onPricingProvinceSelect(event: any, index: number) {
    const fullProvince = this.provinces.find(p => p.id === event.id);
    if (fullProvince) {
      const alreadyAdded = this.pricingAreaRows[index].selectedProvinces.some(p => p.id === fullProvince.id);
      if (!alreadyAdded) {
        this.pricingAreaRows[index].selectedProvinces.push(fullProvince);
      }
    }
  }

  onSelectAllPricingProvinces(events: any[], index: number) {
    const fullObjects = events
      .map(ev => this.provinces.find(p => p.id === ev.id))
      .filter(p => !!p); // remove undefined

    this.pricingAreaRows[index].selectedProvinces = fullObjects;
  }

  onPricingProvinceDeSelect(event: any, index: number) {
    this.pricingAreaRows[index].selectedProvinces =
      this.pricingAreaRows[index].selectedProvinces.filter(
        p => p.id !== event.id
      );
  }

  onDeSelectAllPricingProvinces(event: any, index: number) {
    this.pricingAreaRows[index].selectedProvinces = [];
  }




  // ****************Pricing Areas and Age Banding*****************//
  noOfVariants: number = null;
  noOfAgeBands: number = null;
  isAgeBanded: boolean = false;
  isVariantEnabled: boolean = false;
  selectedBaseUnit: any = null;

  onAgeBandChange(value: boolean): void {
    this.isAgeBanded = value;
    if (value) {
      this.isTiered = false;
      this.noOfTiered = null
      this.tieredRows = [];
    } else {
      this.ageBands = [];
      this.noOfAgeBands = null;
    }
  }
  onTierChange(value: boolean): void {
    this.isTiered = value;

    if (value) {
      this.isAgeBanded = false;
      this.noOfAgeBands = null;
      this.ageBands = [];
    } else {
      this.tieredRows = [];
      this.noOfTiered = null;
    }
  }
  onVarientChange(value: boolean): void {
    this.isVariantEnabled = value;
    this.noOfVariants = null;
    this.variantRows = [];
  }
  onServiceLevelChange(value: boolean): void {
    this.isCategory = value;
    this.noOfCategories = null;
    this.categoryRows = [];
  }
  baseUnitValues = [
    { id: 1, value: '$1' },
    { id: 2, value: '$100' },
    { id: 3, value: '$1000' },
    { id: 4, value: '$10000' },
    { id: 5, value: '$100000' },
    { id: 6, value: '$1000000' }
  ];





  ageBands: any[] = [];
  ageBandErrors: { start: boolean; end: boolean }[] = [];
  variantRows: any[] = []

  generateAgeBands(count: number) {
    this.ageBands = [];
    for (let i = 0; i < count; i++) {
      this.ageBands.push({
        start: null,
        end: null,
      });
    }
    this.noOfAgeBands = count;
  }

  // This updates next row's start when current row's end changes
  onEndChange(index: number): void {
    const currentEnd = this.ageBands[index].end;
    if (index + 1 < this.ageBands.length) {
      this.ageBands[index + 1].start = currentEnd;
    }
  }

  generateVariants(count: number) {
    this.variantRows = [];
    for (let i = 0; i < count; i++) {
      this.variantRows.push({
        name: '',
      });
    }
  }

  // ****************Tiered and Categories*****************//
  isTiered: boolean = false;
  noOfTiered: number = null;
  tieredRows: { name: string }[] = [];

  isCategory: boolean = false;
  noOfCategories: number = null;
  categoryRows: { name: string }[] = [];


  generateTieredRows(count: number) {
    this.tieredRows = Array.from({ length: count }, () => ({ name: '' }));
    if (this.noOfTiered <= 0) {
      this.isTiered = false;
      this.noOfTiered = null;
    } else {
      this.isTiered = true;
    }
  }

  generateCategoryRows(count: number) {
    this.categoryRows = Array.from({ length: count }, () => ({ name: '' }));
    if (this.noOfCategories <= 0) {
      this.isCategory = false;
      this.noOfCategories = null;
    } else {
      this.isCategory = true;
    }
  }


  // ****************No of variantRows***************//
  variantCount: number | null = null;

  variantData: { variant: string; name: string }[] = [];
  updateVariantRows(): void {
    if (this.variantCount && this.variantCount > 0) {
      this.variantData = Array.from({ length: this.variantCount }, () => ({
        variant: '',
        name: ''
      }));
    } else {
      this.variantData = [];
    }
  }

  logVariantData(): void {
    console.log(this.variantData);
  }

  // ****************No of Common Distribution Areas***************//

  distributionAreaCount: number | null = null;

  distributionAreaData: { area: string; name: string }[] = [];

  updateDistributionAreaRows(): void {
    if (this.distributionAreaCount && this.distributionAreaCount > 0) {
      this.distributionAreaData = Array.from({ length: this.distributionAreaCount }, () => ({
        area: '',
        name: ''
      }));
    } else {
      this.distributionAreaData = [];
    }
  }
  logDistributionAreas(): void {
    console.log('Distribution Area Data:', this.distributionAreaData);
  }


  // **********************Pricing Data Section*****************************//

  selectedZone = false;
  selectedTier = false;
  selectedAge = false;
  selectedVariant = false;
  selectedCategory = false;

  showPricingTable = false;
  showTableType: string = '';

  // Pricing matrix for all possible combinations
  pricingMatrix: {
    [zone: string]: any;
  } = {};

  // For simpler tables (zone -> item only, for example)
  flatPricingMatrix: any = {};

  showTable(): void {
    this.updateSelectedFlags();
    this.initializePricingMatrix();
    this.showPricingTable = true;
  }

  updateSelectedFlags(): void {
    this.selectedZone = this.pricingAreaRows.length > 0;
    this.selectedTier = this.tieredRows.length > 0;
    this.selectedAge = this.ageBands.length > 0;
    this.selectedVariant = this.variantRows.length > 0;
    this.selectedCategory = this.categoryRows.length > 0;

    this.resolveTableFormat();
  }
  resolveTableFormat(): void {
    const z = this.selectedZone;
    const t = this.selectedTier;
    const a = this.selectedAge;
    const v = this.selectedVariant;
    const c = this.selectedCategory;

    if (z && t && a && v && c) this.showTableType = 'zone-tier-age-variant-category';
    else if (z && t && a && v) this.showTableType = 'zone-tier-age-variant';
    else if (z && t && a && c) this.showTableType = 'zone-tier-age-category';
    else if (z && t && v && c) this.showTableType = 'zone-tier-variant-category';
    else if (z && a && v && c) this.showTableType = 'zone-age-variant-category';
    else if (t && a && v && c) this.showTableType = 'tier-age-variant-category';
    else if (z && t && a) this.showTableType = 'zone-tier-age';
    else if (z && a && v) this.showTableType = 'zone-age-variant';
    else if (z && a && c) this.showTableType = 'zone-age-category';
    else if (z && t && v) this.showTableType = 'zone-tier-variant';
    else if (z && t && c) this.showTableType = 'zone-tier-category';
    else if (t && a && c) this.showTableType = 'tier-age-category';
    else if (t && v && c) this.showTableType = 'tier-variant-category';
    else if (z && v && c) this.showTableType = 'zone-variant-category';
    else if (t && c) this.showTableType = 'tier-category';
    else if (t && v) this.showTableType = 'tier-variant';
    else if (v && c) this.showTableType = 'variant-category';
    else if (z && t) this.showTableType = 'zone-tier';
    else if (z && v) this.showTableType = 'zone-variant';
    else if (z && c) this.showTableType = 'zone-category';
    else if (t && a) this.showTableType = 'tier-age';
    else if (z && a) this.showTableType = 'zone-age';
    else if (a && c) this.showTableType = 'age-category';
    else if (z) this.showTableType = 'zone-only';
    else this.showTableType = 'default';
  }

  initializePricingMatrix(): void {
    const zRows = this.pricingAreaRows.map(z => z.name || 'default');
    const tRows = this.tieredRows.map(t => t.name || 'default');
    const aRows = this.ageBands.map(a => `${a.start}-${a.end}` || 'default');
    const vRows = this.variantRows.map(v => v.name || 'default');
    const cRows = this.categoryRows.map(c => c.name || 'default');

    for (const z of zRows.length ? zRows : ['default']) {
      for (const t of tRows.length ? tRows : ['default']) {
        for (const a of aRows.length ? aRows : ['default']) {
          for (const v of vRows.length ? vRows : ['default']) {
            for (const c of cRows.length ? cRows : ['default']) {
              this.initializePricingPath(z, t, a, v, c);
            }
          }
        }
      }
    }
  }

  initializePricingPath(...keys: string[]) {
    let ref = this.pricingMatrix;
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i] && keys[i].trim() !== '' ? keys[i] : 'default';

      if (!ref[key]) {
        ref[key] = i === keys.length - 1
          ? {
            'Unit Price': 0,
            'Advisor Commission': 0,
            'TPA Commission': 0,
            'Other Fees': 0
          }
          : {};
      } else if (i === keys.length - 1 && typeof ref[key] === 'object') {
        // If object already exists, patch missing fields (in case of partial data)
        ref[key] = {
          'Unit Price': ref[key]['Unit Price'] ?? 0,
          'Advisor Commission': ref[key]['Advisor Commission'] ?? 0,
          'TPA Commission': ref[key]['TPA Commission'] ?? ref[key]['TPA Commission'] ?? 0,
          'Other Fees': ref[key]['Other Fees'] ?? 0
        };
      }

      ref = ref[key];
    }
  }

  getPricingValue(
    zone: string,
    tier: string,
    age: string,
    variant: string,
    category: string,
    field: keyof PricingDetails
  ): number {
    try {
      return (
        this.pricingMatrix?.[zone || 'default']
        ?.[(tier || 'default')]
        ?.[(age || 'default')]
        ?.[(variant || 'default')]
        ?.[(category || 'default')]
        ?.[field] ?? 0
      );
    } catch {
      return 0;
    }
  }


  setPricingValue(
    zone: string,
    tier: string,
    age: string,
    variant: string,
    category: string,
    field: keyof PricingDetails,
    value: number
  ): void {
    const keys = [zone, tier, age, variant, category].map(k => k || 'default');

    let ref = this.pricingMatrix;
    for (const key of keys) {
      if (!ref[key]) ref[key] = {};
      ref = ref[key];
    }

    ref[field] = value;
  }


  //flat pricing data which we wanted into proper formate
  logFlatPricing() {
    const flatArray = [];

    const walk = (obj: any, path: string[] = []) => {
      for (const key in obj) {
        const value = obj[key];

        // If it's a nested object, go deeper
        if (typeof value === 'object' && !('Unit Price' in value)) {
          walk(value, [...path, key]);
        } else {
          // We've reached the pricing object
          const [zone, tier, ageBand, variant, category] = path;

          flatArray.push({
            zone: zone === 'default' ? false : zone,
            tier: tier === 'default' ? false : tier,
            ageBand: ageBand === 'default' ? false : ageBand,
            variant: variant === 'default' ? false : variant,
            category: category === 'default' ? false : category,
            unitPrice: value['Unit Price'],
            advisorCommission: value['Advisor Commission'],
            tpaCommission: value['TPA Commission'],
            otherFees: value['Other Fees']
          });
        }
      }
    };

    walk(this.pricingMatrix);
    return flatArray
  }



  //*******************************SignUp Form Section*****************************************//
  rows = [
    {
      fields: [
        { fieldName: '', value: '', rule: '' },
        { fieldName: '', value: '', rule: '' },
        { fieldName: '', value: '', rule: '' }
      ]
    }
  ];
  isSavedOnce = false;
  buttonLabel = 'Save';

  addRow() {
    this.rows.push({
      fields: [
        { fieldName: '', value: '', rule: '' },
        { fieldName: '', value: '', rule: '' },
        { fieldName: '', value: '', rule: '' }
      ]
    });
  }
  onFieldChange(): void {
    if(!this.isAllFieldsFilled()){
      this.isSelfBilling= false;
    }
  }

  //validation of next section
  isAllFieldsFilled(): boolean {
    return this.rows.every(row =>
      row.fields.every(field =>
        field.fieldName.trim() !== '' &&
        field.value.trim() !== '' &&
        field.rule.trim() !== ''
      )
    );
  }


  removeRow(index: number) {
    this.rows.splice(index, 1);
    this.isSelfBilling= false;
  }

  saveOrUpdate() {
    if (!this.isSavedOnce) {
      this.buttonLabel = 'Saving...';
      setTimeout(() => {
        this.buttonLabel = 'Saved';
        this.isSavedOnce = true;
        setTimeout(() => {
          this.buttonLabel = 'Update';
        }, 500);
      }, 1000);
    } else {
      this.buttonLabel = 'Updating...';
      setTimeout(() => {
        this.buttonLabel = 'Updated';
        setTimeout(() => {
          this.buttonLabel = 'Update';
        }, 500);
      }, 1000);
    }
  }



  // *********************************Quil Editor************************************//
  editorContent: string = '';
  editorContentForProductResource: string = '';

  safeHtmlContent: SafeHtml = '';
  safeHtmlContentForProduct_Resource: SafeHtml = '';
  quillModules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      ['blockquote', 'code-block'],
      [{ header: 1 }, { header: 2 }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ script: 'sub' }, { script: 'super' }],
      [{ size: ['small', false, 'large', 'huge'] }],
      [{ header: [false, 1, 2, 3, 4, 5, 6] }],
      [{ color: [] }, { background: [] }],
      [{ font: [] }],
      [{ align: [] }],
      ['clean'],
      ['link']
    ]
  };
  quillModulesForProductResource = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      ['blockquote', 'code-block'],
      [{ header: 1 }, { header: 2 }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ script: 'sub' }, { script: 'super' }],
      [{ size: ['small', false, 'large', 'huge'] }],
      [{ header: [false, 1, 2, 3, 4, 5, 6] }],
      [{ color: [] }, { background: [] }],
      [{ font: [] }],
      [{ align: [] }],
      ['clean'],
      ['link']
    ]
  };
  showTileQuillEditor: boolean = false;
  previewQuillEditor: boolean = false;
  showProduct_Resource_QuillEditor: boolean = false;
  previewProduct_Resource_QuillEditor: boolean = false;



  onViewTileDescription() {
    this.safeHtmlContent = this.sanitizer.bypassSecurityTrustHtml(this.editorContent);
    this.previewQuillEditor = true;
  }
  onViewProduct_Resource_Description() {
    this.safeHtmlContentForProduct_Resource = this.sanitizer.bypassSecurityTrustHtml(this.editorContentForProductResource);
    this.previewProduct_Resource_QuillEditor = true;
  }

  onClosePopup() {
    this.previewQuillEditor = false;
  }
  onProductPreviewClosePopup() {
    this.previewProduct_Resource_QuillEditor = false;
  }

  // *********************************Provisioning and Reporting**********************************
  isProvisioning: boolean = null;
  provisioningUrl: string = null;
  provisioningUsername: string = null;
  provisioningPassword: string = null;
  isReporting: boolean = null;
  is2FA: boolean = null;
  isCensus: boolean = null;


  selectedReportingFileTypes: any[] = [];
  reportingFileTypes = [
    { id: 1, name: 'Excel' },
    { id: 2, name: 'PDF' },
    { id: 3, name: 'CSV' }];

  reportingFileTypeDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    itemsShowLimit: 2,
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    enableCheckAll: true,
    allowSearchFilter: true,
  };

  isSelfBilling: boolean = null;
  selectedSelfBillingFields: any[] = [];
  selfBillingFields: any[] = [];
  selfBillingDropdownSettings = {
    singleSelection: false,
    idField: 'fieldName',
    textField: 'fieldName',
    itemsShowLimit: 1,
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    enableCheckAll: true,
    allowSearchFilter: true,
  };
  censusDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    itemsShowLimit: 1,
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    enableCheckAll: true,
    allowSearchFilter: true,
  };


  onProvisioningSelfBilling() {
    const fieldNames = this.rows.flatMap(obj =>
      obj.fields.map(field => field.fieldName)
    );

    // Convert string array to array of objects with fieldName property
    this.selfBillingFields = fieldNames.map(name => ({ fieldName: name }));

    console.log("signup form data:", this.selfBillingFields);

    this.isSelfBilling = true;
  }
  selectedStartMonth: any[] = [];
  selectedEndMonth: any[] = [];

  months = [
    { id: 1, name: 'January' },
    { id: 2, name: 'February' },
    { id: 3, name: 'March' },
    { id: 4, name: 'April' },
    { id: 5, name: 'May' },
    { id: 6, name: 'June' },
    { id: 7, name: 'July' },
    { id: 8, name: 'August' },
    { id: 9, name: 'September' },
    { id: 10, name: 'October' },
    { id: 11, name: 'November' },
    { id: 12, name: 'December' }
  ];
  reportingPeriodDropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'name',
    allowSearchFilter: false,
    closeDropDownOnSelection: true
  };

  // ************Census**********************
  customerFields = [
    { id: 1, name: 'Customer ID' },
    { id: 2, name: 'First Name' },
    { id: 3, name: 'Last Name' },
    { id: 4, name: 'Phone Number' },
    { id: 5, name: 'Province' },
    { id: 6, name: 'Status' },
    { id: 7, name: 'Plan Start Date' },
    { id: 8, name: 'Plan Termination Date' }
  ];
  selectedCensusFields: any[] = [];
  isSelfBillingAndCensusEnabled: boolean = null
  isMaintainHistoryForCensusReporting: boolean = null;

  // ****************************** Delete Product ****************************************
  deleteProduct(productId: string): void {
    this.products = this.products.filter(product =>
      product.productInfo?.productId !== productId
    );
  }
  // **********************Logging data at console*************************
  LogAllData(): void {
    const logData = {
      // supplier info
      supplierID: this.supplierID,
      supplierName: this.supplierName,
      //contact info
      contactInformations: this.contacts,
      // Product Info
      product_ID: this.product_ID,
      product_name: this.product_name,
      effective_Distribution_Date: this.effective_Distribution_Date,
      product_country: this.product_country,
      selectedProvinces: this.selectedProvinces,

      // Limits
      age_: this.age_,
      minAge: this.minAge,
      maxAge: this.maxAge,
      childAgeOut: this.childAgeOut,
      studentAgeOut: this.studentAgeOut,
      isCOB: this.isCOB,
      renewalDate: this.renewalDate,

      // Product Details
      bookletFileName: this.bookletFileName,
      selectedFileName: this.selectedFileName,
      tileFileName: this.tileFileName,

      // Vendor Invoicing and Payment
      billingType: this.billingType,
      bank_code: this.bank_code,
      transit: this.transit,
      account_number: this.account_number,

      // Pricing Section
      isBaseAmount: this.isBaseAmount,
      taxApplicable: this.taxApplicable,
      taxTypes: this.taxTypes,
      inclusiveTax: this.inclusiveTax,

      // Pricing Areas
      noOfPricingAreas: this.noOfPricingAreas,
      pricingAreaRows: this.pricingAreaRows,

      // Tiers
      isTiered: this.isTiered,
      noOfTiered: this.noOfTiered,
      tieredRows: this.tieredRows,

      // Service Level
      isCategory: this.isCategory,
      noOfCategories: this.noOfCategories,
      categoryRows: this.categoryRows,

      // Age Banding
      isAgeBanded: this.isAgeBanded,
      noOfAgeBands: this.noOfAgeBands,
      ageBands: this.ageBands,
      isVariantEnabled: this.isVariantEnabled,
      noOfVariants: this.noOfVariants,
      variantRows: this.variantRows,
      selectedBaseUnit: this.selectedBaseUnit,

      // Pricing Matrix
      pricingMatrix: PricingMatrixHelper.transform(this.pricingMatrix),

      // Additional Output
      areaWiseAgeBandPricing: this.pricingAreaRows,
      signUpFormData: this.rows
      // Uncomment if needed:
      // province: this.province,
      // areaWiseVariantPricing: this.areaWiseVariantPricing,
    };

    console.log("Logged Data Object:", logData);
  }

  LogAllDataForConsole(): void {
    // Product Info
    console.log('Product ID:', this.product_ID);
    console.log('Product Name:', this.product_name);
    console.log('Supplier ID:', this.supplierID);
    console.log('Eff Dist Date:', this.effective_Distribution_Date);
    console.log('Dist Country:', this.product_country);
    console.log('Distribution Provinces:', this.selectedProvinces);

    // Limits
    console.log('Age Limited:', this.age_);
    console.log('Age Limited Min-Age:', this.minAge);
    console.log('Age Limited Max-Age:', this.maxAge);
    console.log('Age Limited childAgeOut:', this.childAgeOut);
    console.log('Age Limited studentAgeOut:', this.studentAgeOut);
    console.log('COB Rules Apply:', this.isCOB);
    console.log('Renewal Date:', this.renewalDate);

    // Product Details
    console.log('Booklet File:', this.bookletFileName);
    console.log('Product Resource Info File:', this.selectedFileName);
    console.log('Tile Description File:', this.tileFileName);

    // Vendor Invoicing and Payment
    console.log('Billing Type:', this.billingType); // 'Self Billing' or 'Invoiced'
    console.log('Bank Code:', this.bank_code);
    console.log('Transit:', this.transit);
    console.log('Account Number:', this.account_number);

    // Pricing Section
    console.log('Are taxes applicable?:', this.taxApplicable);
    console.log("taxTypes :", this.taxTypes)

    console.log('Is price inclusive of tax?:', this.inclusiveTax);


    // Pricing Areas
    console.log('Number of Pricing Areas:', this.noOfPricingAreas);
    console.log('Pricing Area Rows:', this.pricingAreaRows);

    // Tiers
    console.log('Tiers Enabled:', this.isTiered);
    console.log('Number of Tiers:', this.noOfTiered);
    console.log('Tiers Data:', this.tieredRows);

    // Service Level
    console.log('Service Level Enabled:', this.isCategory);
    console.log('Number of Service Levels:', this.noOfCategories);
    console.log('Service Levels Data:', this.categoryRows);

    // Age Banding
    console.log('Is Age Band enable:', this.isAgeBanded);
    console.log('Number of Age Bands:', this.noOfAgeBands);
    console.log('Age Band Data:', this.ageBands);
    console.log('Is Variant enable:', this.isVariantEnabled);
    console.log('Number of Variants:', this.noOfVariants);
    console.log('Variant Rows:', this.variantRows);
    console.log('Base Unit Value:', this.selectedBaseUnit);

    // Pricing Matrix
    console.log('Pricing Matrix:', this.pricingMatrix);
    console.log('logFlatPricing :', this.logFlatPricing());
    console.log("Final Pricing table input values :", PricingMatrixHelper.transform(this.pricingMatrix))

    // Additional Pricing Output (Optional)
    console.log('Area-wise Age Band Pricing:', this.pricingAreaRows);

    // Singup form value
    // console.log('Pricing Zone Area Matrix:', this.province);
    // console.log('Area-wise Variant Pricing Final Output:', this.areaWiseVariantPricing);
  }

  states: any[] = [];
  countryId = 1; // example country ID
  apiUrl = `${environment.apiUrl}`;

  getStatesByCountryId() {
    // this.http.get(`${this.apiUrl}/api/ap/countries/${this.countryId}/states-and-provinces`)
    //   .subscribe((res: any) => {
    //     this.provinces = res;
    //     console.log("prssssssssssss:", this.provinces)
    //   });
    this.http.get(`${this.apiUrl}/api/ap/partners`)
      .subscribe((res: any) => {
        // this.provinces = res;
        // console.log("prssssssssssss:", this.provinces)
        console.log("partners data :", res)
      });
  }
  ngOnInit(): void {
    console.log("existingSuppliers :", this.existingSuppliers)
    this.getLanguageTokens(); // Load language on init
    this.getStatesByCountryId();
    this.supplierID = this.generateSupplierID();
    console.log("SupplierID:", this.supplierID);
    this.editor = new Editor({
      history: true,
      keyboardShortcuts: true,
      inputRules: true,
    }); // Create Tile editor on page load
    this.product_resource_editor = new Editor({
      history: true,
      keyboardShortcuts: true,
      inputRules: true,
    }); // Create product resouce info

    // VALIDATION FOR CONTACT FORM
    this.contactForm = this.formBuilder.group({
      firstName: ['', RxwebValidators.required()],
      lastName: ['', RxwebValidators.required()],
      email: ['', [RxwebValidators.required(), RxwebValidators.email()]],
      phone: [
        '',
        [
          RxwebValidators.required(),
          RxwebValidators.pattern({ expression: { exactTen: /^.{10}$/ } })
        ]
      ]
      ,
      role: ['', RxwebValidators.required()],
      contact_other: ['']
    });

    var signinResults = JSON.parse(sessionStorage.getItem('signinResults'));
    this.username = signinResults?.userInfo?.name;
    this.user_role = signinResults?.userInfo.role;
    // this.portalInfo = signinResults?.portalInfo;

  }

  // **************************Adding Supplier into Database***************************
  username: string = "";
  user_role: string = "";
  showCreatedSupplierPopup: boolean = false;

  onSubmitSupplier(): void {
    this.contacts = this.contacts.map((contact, index) => ({
      ...contact,
      id: index + 1,
    }));
    const payload = {
      supplierName: this.supplierName.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
      supplierId: this.supplierID,
      products: this.products,
      contactInfo: this.contacts,
      catalogVersion: 'v1.0',
      history: [
        {
          action: 'Created',
          by: this.username,
          role: this.user_role,
          at: new Date().toISOString()
        }
      ],
      created: new Date().toISOString(),
      modified: new Date().toISOString()
    };


    console.log("payload :", payload);
    const url = `${environment.apiUrl}/api/ap/suppliers`;

    this.http.post(url, payload).subscribe({
      next: (res) => {
        console.log('Supplier created successfully', res);
        this.showCreatedSupplierPopup = true;
      },
      error: (err) => {
        console.error('Error creating supplier', err);
      }
    });
  }

  // ***************************************** Edit Supplier Product ******************************
  selectedProduct: any = {};
  editSingleProductModal: boolean = false;
  selectedSupplierId: number = 0;
  editProduct(product: any): void {
    this.selectedProduct = product;
    this.editSingleProductModal = true;
  }

  onProductUpdated(updated: any) {
    this.products = this.products.map(p =>
      p.productId === updated.productId ? updated : p
    );
    this.editSingleProductModal = false
  }

  ngOnDestroy(): void {
    this.editor.destroy(); // Clean up editor when leaving the page
  }
}


export interface PricingDetails {
  'Unit Price'?: number;
  'Advisor Commission'?: number;
  'TPA Commission'?: number;
  'Other Fees'?: number;
}